import Image from 'next/future/image';
import Link from 'next/link';
import { categoryNameToHandle } from '@lambda/reebelo/src/commonHelpers';
import { useState } from 'react';
import { CategoryLandingPageKey } from '@lambda/apis/src/category/types';
import Section from '@/components/commons/Section';
import FeaturedArea from './FeaturedArea';
import ProductGrid from './ProductGrid';
import { useCategoryLandingPageSearchApi } from '../use-category-landing-search-api';
import { generateCategoryPageUrl } from '../helpers';
import { SubCategoryDataT } from '../types';
import ChevronRightIcon from '@/public/icons/product/chevronRight.svg';

const SubCategorySection = ({
  category,
  handle,
}: {
  category: SubCategoryDataT;
  handle: CategoryLandingPageKey;
}) => {
  const [showSection, setShowSection] = useState(true);
  const sectionTitle = category.config.title;
  const categoryHandle = categoryNameToHandle(category.name);

  const link = generateCategoryPageUrl(category.name, category.pk);

  // Data Fetching
  const { data, loading } = useCategoryLandingPageSearchApi(
    category.categories,
  );

  if (!showSection) return null;

  return (
    <Section className="group py-8 odd:bg-gray-200" key={category.pk}>
      <div className="reebelo-container">
        <div className="flex items-end justify-between">
          <h2 className="flex items-center text-lg font-semibold md:text-xl">
            {sectionTitle}
          </h2>
          <Link href={link}>
            <a className="mb-1 flex items-center gap-2 text-xs font-bold hover:underline md:mb-0 md:text-sm">
              <span>
                See all <span className="hidden xs:inline">Products</span>
              </span>
              <div className="h-2.5 w-2.5 shrink-0">
                <Image
                  src={ChevronRightIcon}
                  alt="Chevron Right"
                  height={20}
                  width={20}
                  className="h-full w-full"
                />
              </div>
            </a>
          </Link>
        </div>
        <div className="mt-3 flex flex-col gap-3 lg:flex-row group-odd:lg:flex-row-reverse">
          <FeaturedArea
            category={category}
            handle={handle}
            categoryHandle={categoryHandle}
            link={link}
          />
          <ProductGrid
            offers={data}
            setShowSection={setShowSection}
            loading={loading}
          />
        </div>
      </div>
    </Section>
  );
};

export default SubCategorySection;
